import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class PaymentSchedulesDataProvider {
	constructor(private http: HttpClient) {}

	getPaymentScheduleOptions(): Observable<any> {
		/* headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		} */
		const url = '/protected/rest/payment_schedule_options';
		return this.http.get(url);
	}

	createPaymentSchedule(data): Observable<any> {
		const url = '/protected/rest/payment_schedule/create';
		return this.http.post(url, data);
	}

	updatePaymentSchedule(data): Observable<any> {
		const url = '/protected/rest/payment_schedule/update';
		return this.http.post(url, data);
	}

	deletePaymentSchedule(data): Observable<any> {
		const url = '/protected/rest/payment_schedule/delete';
		return this.http.post(url, data);
	}

	getPaymentsSchedules(params): Observable<any> {
		const url = '/protected/rest/company_payment_schedules';
		return this.http.get(url, { params });
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/payments/payments-schedules-data-service/payments-schedules.data.service.ts